import { queryOptions } from '@tanstack/react-query';
import damagesInformationDataGenerator from '@/modules/FileDetail/data/damagesInformation/damagesInformationDataGenerator.tsx';
import { damagesInformationQueryFunction } from '@/modules/FileDetail/queries/damagesInformation/damagesInformationQueryFunction.ts';

export const damagesInformationQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['damages_information', id],
    queryFn: () => damagesInformationQueryFunction(id),
    enabled: !!id,
    select(data) {
      return {
        data,
        results: data.map((item) => damagesInformationDataGenerator(item)),
      };
    },
  });
